<template>
  <el-input
  :disabled="disabled"
  :placeholder="column.showContent | capitalize"
  v-model="input"
  @blur="handlerBlur" />
</template>

<script>
export default {
  props: ['column', 'scope'],
  filters: {
    capitalize(val) {
      if (val) {
        return val.replace(/&nbsp;/g, '').replace(/<\/?[^>]*>/g, '')
      } else {
        return '自动计算'
      }
    }
  },
  data() {
    const {
      disabled,
      label
    } = this.column
    return {
      disabled,
      placeholder: disabled ? '' : `请输入${label}`,
      input: this.scope.row[this.column.prop]
    }
  },
  watch: {
    scope({ row }) {
      const val = row[this.column.prop]
      const old = this.input
      if (val && old !== val) {
        this.input = val
      }
    }
  },
  methods: {
    handlerBlur() {
      this.$emit('on-edit', this.input, this.column.prop, this.scope.$index)
    }
  }
}
</script>
